export const paymentGatewayVendorConstant = {
  STRIPE: "STRIPE",
  EBIX: "EBIX",
  RAZORPAY: "RAZORPAY",
  LEAP_PAYMENT: "LEAP_PAYMENT",
  RAZOR_PAY_LINK: "RAZOR_PAY_LINK",
  BKASH: "BKASH",
};
